import dChallenge from '../images/Logo_DiversityChallenge_tapevisual.svg';
import BMFSFJ from '../images/Logo_BMFSFJ.svg';
import { Customization, css } from '@eduvision/toolkit';
import headerImage from '../images/start-hero.png';
import { default as CustomLoggedOutView } from '../views/LoggedOutView';

export const LoggedOutView: Customization['LoggedOutView'] = {
	component: CustomLoggedOutView,
	// headerImageSrc: headerImage,
  // hideDemoSection: true,
  // credits: [
  //   {
  //     imageSrc: dChallenge,
  //     imageAlt: 'Diversity Challenge',
  //     imageWidth: 200
  //   },
  //   {
  //     imageSrc: BMFSFJ,
  //     imageAlt: 'BMFSFJ',
  //     imageWidth: 550
  //   }
  // ],
  // add custom style to existing component
  // customStyle: css`
  //   &{
  //     /* custom style */
  //   }
  //   & .CategoriesSection{
  //     background-color: ${p=>p.theme.palette.secondary.main};
  //   }
  // `
};
